// extracted by mini-css-extract-plugin
export default {"closeButton":"closeButton__CloseButton__g+fIn","icon":"icon__CloseButton__g+fIn","closeButtonWithLabel":"closeButtonWithLabel__CloseButton__g+fIn"};